import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';
import { Lock } from 'lucide-react';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAdmin();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (login(password)) {
      navigate('/admin/dashboard');
    } else {
      setError('Invalid password');
      setPassword('');
    }
  };

  return (
    <div className="page-content">
      <section className="admin-login-section">
        <div className="container">
          <div className="admin-login-card network-card" style={{ maxWidth: '500px', margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <Lock size={48} style={{ color: 'var(--brand-primary)', marginBottom: '16px' }} />
              <h1 className="heading-1" style={{ marginBottom: '8px' }}>Admin Login</h1>
              <p className="body-medium">Pacific Ghost Baseball</p>
            </div>
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Enter admin password"
                  autoFocus
                />
              </div>
              
              {error && (
                <div style={{ color: 'red', marginBottom: '16px', textAlign: 'center' }}>
                  {error}
                </div>
              )}
              
              <button type="submit" className="btn-primary" style={{ width: '100%' }}>
                Login
              </button>
            </form>
            
            <div style={{ marginTop: '24px', padding: '16px', background: 'var(--bg-subtle)', borderRadius: '12px' }}>
              <p style={{ fontSize: '14px', margin: 0, color: 'var(--text-secondary)' }}>
                <strong>Demo Password:</strong> PacificGhost2025
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminLogin;